import { Component, resource } from '@angular/core';
import { ApiService } from '../api/api.service';
import { KENDO_GRID, SelectionEvent } from '@progress/kendo-angular-grid';
import { UserRightsComponent } from "../user-rights/user-rights.component";
import { Button } from "@progress/kendo-angular-buttons";
import { trashIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'user-list',
  imports: [KENDO_GRID, UserRightsComponent, Button],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css',
})
export class UserListComponent {

  public trashIcon = trashIcon;

  constructor(public apiService: ApiService) {
    
  }


  public selectedUser: string | undefined;  

  public users = resource({
    loader: async () => {
      let users = await this.apiService.client.getUsers.query();
      console.log(users);
      return users.users as any[];
    }
  });

  public onSelectionChange(event: SelectionEvent) {
    if (event.selectedRows != undefined && event.selectedRows.length > 0) {
      this.selectedUser = event.selectedRows[0].dataItem.sub;
    }
    
  }

  public async refreshFromDB() {
    await this.apiService.client.refreshCasbin.mutate();
    this.users.reload();
  }

  public async removeUser(sub: string) {
    await this.apiService.client.removeUser.mutate({sub: sub});
    this.users.reload();
  }

}
